// The dashboard's product name. Kept in one place so the navigation, the page
// heading and the walkthrough can never drift apart.
export const DASHBOARD_LABEL = 'Oomero Pulse';
